import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { STARSHIPIT_API_KEY, STARSHIPIT_SUBSCRIPTION_KEY } from '@/config/env';

const BASE_URL = 'https://api.starshipit.com/api';

export type StarshipitOrder = {
  order_id: number;
};

export type OrderResponse = {
  order: StarshipitOrder;
};

export type PrintLabelResponse = {
  labels?: string[];
  success: boolean;
};

type PrintLabelParams = {
  orderNumber: string;
  packages: {
    height: number;
    width: number;
    length: number;
    weight: number;
  }[];
};

const axiosApiService = axios.create();

// request interceptor to add the auth token header to requests
axiosApiService.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      config.headers['StarShipIT-Api-Key'] = STARSHIPIT_API_KEY;
      config.headers['Ocp-Apim-Subscription-Key'] = STARSHIPIT_SUBSCRIPTION_KEY;
    }
    return config;
  },
  error => Promise.reject(error),
);

export const getOrder = (
  orderNumber: string,
): Promise<AxiosResponse<OrderResponse>> => {
  return axiosApiService.get(`${BASE_URL}/orders?order_number=${orderNumber}`);
};

export const printLabel = ({
  orderNumber,
  packages,
}: PrintLabelParams): Promise<AxiosResponse<PrintLabelResponse>> => {
  return axiosApiService.post(`${BASE_URL}/orders/shipment`, {
    order_number: orderNumber,
    packages,
  });
};
